import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

const ScheduleInternalMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("intSelectedScheduleCard"),
    );

    if (storedSelectedApproval) {
      const transactions = storedSelectedApproval?.[0]?.selectedDetails || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.[0]?.selectedDetails);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval?.[0]?.selectedIds);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/internal_transaction_dashboard");
  };

  const approveMoreSchedules = () => {
    navigate("/internal_transaction_dashboard/schedule_multi_approval");
  };

  const buttonRows = [
    [
      {
        btnText: "Approve more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreSchedules,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const ScheduleList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions.map((account, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: account?.scheduled_name,
              leftSubTitle: "Schedule name",
              hasRight: true,
              rightText: true,
              rightTitleTextColor: "var(--text-primary)",
              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightTextFontWeight: "semibold",
              rightSubTitle: "Amount",
              rightIcon: true,
              onClick: () =>
                navigate(
                  `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      title={successPageData.length && "Schedules approved successfully."}
      buttonRows={buttonRows}
    >
      {successPageData.length > 0 && (
        <TabsWeapperSection
          title={`Approved Schedules - ${successPageID.length}`}
        >
          <ScheduleList transactions={successPageData} />
        </TabsWeapperSection>
      )}
    </StatusContainer>
  );
};

export default ScheduleInternalMultiApprovalSuccess;
